import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(
  _theme => ({
    container: {
      height: "fit-content",
      maxHeight: 750,
      width: "100%",
      overflowY: "auto"
    },
    checkboxHeaderCell: {
      width: 50
    },
    checkboxBodyCell: {
      width: 50,
      borderBottom: "none"
    },
    unlockCodeHeaderCell: {
      fontWeight: 600,
      minWidth: 150,
      width: 200
    },
    unlockCodeBodyCell: {
      "& > div": {
        overflow: "hidden",
        whiteSpace: "nowrap"
      },
      minWidth: 150,
      width: 200,
      fontWeight: 700,
      borderBottom: "none"
    },
    usageLimitHeaderCell: {
      fontWeight: 600,
      minWidth: 125,
      width: 150
    },
    usageLimitBodyCell: {
      minWidth: 125,
      width: 150,
      borderBottom: "none"
    },
    descriptionHeaderCell: {
      fontWeight: 600,
      minWidth: 175
    },
    descriptionBodyCell: {
      "& > div": {
        overflow: "hidden",
        whiteSpace: "nowrap"
      },
      minWidth: 175,
      borderBottom: "none"
    },
    actionsHeaderCell: {
      position: "relative",
      right: 24,
      fontWeight: 600,
      minWidth: 180,
      width: 180
    },
    actionsBodyCell: {
      minWidth: 180,
      width: 180,
      borderBottom: "none"
    }
  }),
  {
    name: "UnlockCodesTable"
  }
);
